module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "part-001"
    }
  }, [_c('div', {
    staticClass: "part_debut"
  }), _c('h1', {
    staticClass: "part_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE"), _c('br'), _vm._v("TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS")])])])]), _c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-001"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('span', [_vm._v("PAUL AND THE GOSPEL"), _c('br')])]), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Romans+1:1-7&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("ROMANS 1:1-7")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW")]), _vm._v(": ")]), _vm._v("The first seven verses of Romans 1 serve as an introduction to the whole epistle, and the Fathers made many comments on them that nowadays would normally be found in a general preface. They were especially fascinated by the name Paul itself and sought to discern why it had been changed from Saul. The Fathers were also interested in the fact that Paul called himself a servant (slave), which is not surprising given the fact that they were living in a slave-holding society. Nor were they slow to link the apostle’s sense of his calling to God’s foreknowledge and predestination. This tendency to move from particular details to universal concepts is typical of the ancients generally, and so we must not be surprised to discover that verses like these could be used as a basis for profound theological reflections.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("All the Fathers accepted the validity of Old Testament prophecy concerning the coming of Christ, but they were capable of seeing this from many different angles. Some stressed the importance of the gospel as distinct from the coming of Christ in the flesh; others focused on the role of the prophets, and Augustine was concerned to point out that there had been Gentiles as well as Jews who had foretold his coming. Especially from the fourth century onward, the Fathers all emphasized that Christ was the eternal Son of God, because this had by then become the main point in dispute with the Arians. But John Chrysostom was bold enough to point out that in the order of revelation believers came to know the human Christ before they understood that he was God. Romans 1:4 received an enormous amount of attention from the Fathers, because it seemed to suggest that Jesus of Nazareth was merely a man who was “designated” Son of God after his resurrection. All of them took great pains to insist that this was not what Paul meant. Of particular interest in this respect is the "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("lengthy passage from Origen, which obviously has been touched up by Rufinus. In the authentically Origenist part we find that the great biblical scholar was prepared to admit that Joseph could be called the father of Jesus—in an allegorical sense. This use of allegory is the exact opposite of what a modern commentator would suppose, since for moderns it is not the fatherhood of Joseph but the doctrine of the virgin birth of Christ that causes problems and might be regarded as an allegorical reading of those Old Testament texts that are quoted as prophecies of his coming.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Paul received his commission by grace, not because he had any special entitlement to it. Moreover, the word "), _c('i', [_vm._v("apostle")]), _vm._v(" had more than one meaning, and it was was not always restricted to a special office as it is in Romans 1:5. Since the gift of God is given to all, all believers from all nations are called to the obedience of faith, even though not all are Jews and not all are apostles. God’s love has presented us with grace, and grace with peace. Paul prayed that all who are called might receive the grace of God, by which all believers enjoy salvation, and peace, by which God gives to all the restoration of excellent behavior.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-010"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('span', {
    staticClass: "r"
  }, [_c('i', [_vm._v("1:1 ")]), _vm._v("A Servant of Jesus Christ")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLED TO ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E AN ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("POSTLE. ")])]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("The first question which occurs to us concerns the name Paul itself. Why is he, who in Acts")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN7",
      "id": "ap_NFIN7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" was called Saul, now called Paul? In Holy Scripture we find that among the ancients, many names were altered, e.g., Abram was renamed Abraham,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN8",
      "id": "ap_NFIN8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Sarai became Sarah,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN9",
      "id": "ap_NFIN9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" and Jacob became Israel."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN10",
      "id": "ap_NFIN10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" In the Gospels too, Simon was changed to Peter,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN11",
      "id": "ap_NFIN11-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" and the sons of Zebedee became known as sons of thunder."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN12",
      "id": "ap_NFIN12-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" But these things occurred by divine command, and we read nothing of the sort in the case of Paul. Because of this, some people have imagined that the apostle took the name of Paul, the proconsul of Cyprus, whom he converted to the Christian faith,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN13",
      "id": "ap_NFIN13-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" in the same way that rulers are in the habit of adding the names of conquered peoples to their titles, e.g., Parthicus would indicate someone who conquered the Parthians, Gothicus a victor over the Goths, and so on. In the same way the apostle would have called himself Paul to indicate that he had conquered the proconsul Paul.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We cannot exclude this reason completely, but given that no such custom can be found in Holy Scripture, we ought rather to seek a solution from the examples which we do have. And indeed we find in the Scriptures that some people have two or even three different names, e.g., Solomon is also called Jedidiah,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN14",
      "id": "ap_NFIN14-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Zedekiah is also called Mattaniah,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN15",
      "id": "ap_NFIN15-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Uzziah is also called Azariah,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN16",
      "id": "ap_NFIN16-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" and there are many others in the books of Judges, Samuel and Kings who have double names. But even the Gospels do not abandon this custom, e.g., Matthew was called Levi"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN17",
      "id": "ap_NFIN17-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" . . . and Thaddeus sometimes appears as Lebbaeus."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN18",
      "id": "ap_NFIN18-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Obviously the Gospel writers did not get the names of the apostles wrong, but given that it was the custom of the Hebrews to have two or three names, they gave different names to one and the same man. It seems to us that it is in accordance with this custom that Paul appears to have a second name, and that as long as he was ministering to his own people he was called Saul, which was probably the name his parents gave him, but that when he was writing laws and commandments for the Greeks and other Gentiles, he was called Paul. Scripture makes it clear when it says: “Saul, who is also called Paul,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN19",
      "id": "ap_NFIN19-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" that the name Paul was not then being given to him for the first time but was already habitual.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But why does Paul call himself a slave, when elsewhere he says: “For you did not receive the spirit of slavery to fall back into fear, but you have received the Spirit of sonship, by which we cry Abba! Father!”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN20",
      "id": "ap_NFIN20-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" . . . We may understand this as an expression of humility . . . and that would not "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("be wrong. Nor is the reality of Paul’s freedom compromised by this in any way. As he himself says: “Though I am free from all men, I have made myself a slave to all.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN21",
      "id": "ap_NFIN21-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(". . . For he serves Christ not in the spirit of slavery but in the spirit of adoption, for Christ’s service is more noble than any freedom.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Called” is the name given to everyone who believes in Christ and is therefore a general term, although it is applied to each one according to what God has foreseen and chosen in him. He may be called to be an apostle or a prophet or a teacher; as free from a wife or as bound in marriage, and this is determined by the diversity of grace given to everyone, as it is written: “Many are called but few are chosen.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN22",
      "id": "ap_NFIN22-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In Paul’s case, he was not called to be an apostle in the general sense, but he was also chosen according to the foreknowledge of God to be “set apart for the gospel of God,” as he says elsewhere: “God set me apart before I was born and called me through his grace.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN23",
      "id": "ap_NFIN23-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" Heretics wrongly claim that he was set apart from his mother’s womb on account of the goodness of his nature, just as from the opposite side of the fence we read in the Psalms of those “sinners who were separated from the womb”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN24",
      "id": "ap_NFIN24-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" because of their evil nature.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But we say that Paul was chosen neither by accident nor because of some natural difference, but he himself attributed the causes of his election to him who knows everything before it happens. . . . For God foresaw that Paul would labor more abundantly than anyone else in the gospel . . . and for that reason Jesus set him apart in his mother’s womb for the gospel. Had he been chosen by fate, as the heretics maintain, or by some inherently better nature, he would not have been afraid of being condemned if he failed to preach the gospel."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN25",
      "id": "ap_NFIN25-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("God’s foreknowledge, by which those who will labor and succeed are known, comes first, and his predestination follows afterwards, so that foreknowledge cannot be regarded as the cause of predestination. With men, merits are weighed according to past actions, but with God they are weighed according to future behavior, and anyone who thinks that God cannot see our future just as easily as he can see our past is an unbeliever. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN26",
      "id": "ap_NFIN26-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLED AS ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERVANT AND ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("POSTLE.")])]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USEBIUS OF ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MESA: ")]), _vm._v("Some people argue quite pointlessly as to whether the participle "), _c('i', [_vm._v("called")]), _vm._v(" is meant to modify "), _c('i', [_vm._v("servant")]), _vm._v(" or "), _c('i', [_vm._v("apostle.")]), _vm._v(" It applies to both, since everyone is called, and called equally, both to faith and grace and to election and the apostolic order. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN27",
      "id": "ap_NFIN27-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROM ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTLESSNESS TO ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EST.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("Saul changed his name to Paul, and the change was permanent. Because Saul means restlessness or trial, when he came to faith in Christ he called himself Paul, i.e., rest, because our faith is peace. For whereas previously he had inflicted trials on the servants of God because of his desire to fulfill the law, later he himself endured trials on account of the hope which before he had denied because of his love of Judaism.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In calling himself a “servant of Jesus Christ,” Paul shows that he has been delivered from the law, and he puts both names, Jesus and Christ, in order to signify the person of God and man, for in both he is Lord, as Peter the apostle testifies, saying: “He is the Lord of all.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN28",
      "id": "ap_NFIN28-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" And because he is Lord, he is also God, as David says: “For the Lord himself is God.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN29",
      "id": "ap_NFIN29-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" The heretics deny this. Marcion, it seems, denied Christ and his body out of hatred for the law, although he confessed Jesus. The Jews and Photinus denied that Jesus was God out of their zeal for the law. For whenever Scripture says either “Jesus” or “Christ,” it sometimes means the person of God and sometimes the person of the man, e.g.: “there is one Lord Jesus Christ, through whom are all things.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN30",
      "id": "ap_NFIN30-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("“Called to be an apostle.” Because Paul acknowledged the Lord and confessed him he became the perfect servant and shows that he was promoted, saying that he was called to be an apostle, i.e., a messenger sent by the Lord to do his work. By this he shows that he had merit with God because he served Christ and not the law.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("“Set apart for the gospel of God.” The gospel of God is good news, by which sinners are called to forgiveness. For since as a Pharisee the apostle held a teaching post among the Jews, he now says that he has been set apart from the preaching of Judaism for the gospel of God, so that abandoning the law, he might preach Christ who justifies those who believe in him, which the law could not do. This does not go against the law but affirms it, since the law itself says that this will happen in the future, in the words of Isaiah the prophet: “There will come from Zion one who will break and remove the captivity of Jacob, and this will be a testimony of me, when I shall take away their sins.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN31",
      "id": "ap_NFIN31-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN32",
      "id": "ap_NFIN32-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ET ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PART. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("POLLINARIS OF ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AODICEA:")])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Paul was set apart and dedicated to evangelism, like the offerings which the law says were set apart for God and for the priests."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN33",
      "id": "ap_NFIN33-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN34",
      "id": "ap_NFIN34-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLED FROM ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAVEN.")])]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVERIAN: ")]), _vm._v("Paul here preaches the divinity of Christ to a world which was ignorant of it. Many people saw the Lord, and others believed in him without seeing, but Paul was called from heaven: “Saul, Saul, why do you persecute me?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN35",
      "id": "ap_NFIN35-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" He was more highly favored than the other apostles, for the Lord called Peter and James and John and made them his disciples; he did not immediately make or call them apostles. But he made Paul an apostle as soon as he called him. Thus the gospel is preached according to the plan of God. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN36",
      "id": "ap_NFIN36-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AME OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Moses wrote five books, but nowhere did he put his own name to them . . . nor did Matthew, John, Mark or Luke. But St. Paul everywhere in his epistles puts his own name."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN37",
      "id": "ap_NFIN37-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" Why? Because the others were writing to people who were present, and it would have been superfluous for them to have announced themselves when they were present. But Paul sent his writings from a distance and in the form of a letter, and so he had to add his name.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Why did God change his name and call him Paul instead of Saul? It was so that even in this respect he might not come short of the apostles but that he might also have the same preeminence that the chief of the disciples had"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN38",
      "id": "ap_NFIN38-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" and on that basis be more closely united with them. Paul also calls himself the “servant” of Christ, and there are many kinds of servitude. One is related to creation, “for all things are thy servants.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN39",
      "id": "ap_NFIN39-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" Another comes from faith"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN40",
      "id": "ap_NFIN40-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" and a third is civil subjection, as it says: Moses my servant is dead."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN41",
      "id": "ap_NFIN41-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Indeed, all the Jews were servants, but Moses in a special way, since his light has shone most brightly in the community. Paul was a servant in all of these senses, and therefore he puts this term first, in the place of greatest dignity.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("He says of himself, in all of his epistles, that he is “called,” thereby demonstrating his own candor in admitting that it was not because he sought that he found but that when he was called, he came near and obeyed."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN42",
      "id": "ap_NFIN42-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN43",
      "id": "ap_NFIN43-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('b', [_vm._v("A S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERVANT ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE OF ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPSUESTIA:")])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("All things are servants of Christ, and he is Lord of all. Therefore Paul calls himself a servant first of all, thereby encouraging the rest to do likewise. He also recalls the unique lordship of the Son but not in such a way as to deny the lordship of the Father, which is confessed by everybody. In saying that he was set apart, he showed "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("that he was not only called but also chosen from among many as useful for the preaching of the gospel. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN44",
      "id": "ap_NFIN44-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLED AND ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ET ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PART.")])]), _c('span', {
    staticClass: "small"
  }, [_vm._v(" [")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SEUDO-]")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSTANTIUS: ")]), _vm._v("Just as the names of other saints both in the Old and in the New Testament, e. g., Abraham and Peter and the rest, were changed in accordance with the advance and increase of their merits, so also Paul, as he grew in the grace of God, changed his name. He was a servant not out of fear but out of love, as he himself says: “It is no longer I who live, but Christ lives in me.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN45",
      "id": "ap_NFIN45-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" He reveals that he was not only “called” to the grace of apostleship but “set apart” for preaching to the Gentiles, as he himself records: “We to the Gentiles and they to the circumcision.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN46",
      "id": "ap_NFIN46-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" Called therefore by Christ to the apostleship, he was set apart for preaching to the Gentiles by the Holy Spirit, so that it might be revealed that the Father, Son and Holy Spirit are all of one substance. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLY ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER OF ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T. ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN47",
      "id": "ap_NFIN47-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLED ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORTH.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("By these two words, "), _c('i', [_vm._v("called")]), _vm._v(" and "), _c('i', [_vm._v("set apart,")]), _vm._v(" Paul distinguishes between the church, which is acceptable to God, and the synagogue, whose glory has faded away. The church (i.e., "), _c('i', [_vm._v("ecclesia)")]), _vm._v(" is so called because it “calls forth”: the synagogue, because it “gathers together.” R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDIMENTARY ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPOSITION OF THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 2.1-3, 5.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN48",
      "id": "ap_NFIN48-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AME.")])]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN49",
      "id": "ap_NFIN49-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _c('span', {
    staticClass: "small"
  }, [_vm._v(": ")]), _vm._v("Do we wonder why he writes "), _c('i', [_vm._v("Paul,")]), _vm._v(" given that he was called Saul before? Doubtless he did this following the habit of the saints. When they advanced in virtue they were addressed with a different name, so that they might be new people even in name, e.g., Abraham, Sarah and Cephas."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN50",
      "id": "ap_NFIN50-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" . . . Paul earned the office of an apostle by faithful and matchless service. He was set apart in Acts 13:2. "), _c('i', [_vm._v("Gospel")]), _vm._v(" . . . means “good news”, i.e., of Christ’s birth, suffering, resurrection and ascension into heaven. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS’S ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN51",
      "id": "ap_NFIN51-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALUTATION OF ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACE.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR: ")]), _vm._v("Civil governors and military commanders put their titles at the beginning of their letters in order to boast and show off. But St. Paul says that he was born out of due time, that he is the chief of sinners and that he is unworthy of his apostleship. Nevertheless, when writing his letters, he starts with the words imposed on him by grace, for the benefit of those who receive them. For when the recipients realized the importance of the person who was writing to them, they would read the letter with greater earnestness and attention. I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERPRETATION OF THE ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN52",
      "id": "ap_NFIN52-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-011"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('i', [_vm._v("1:2")]), _vm._v(" The Promised Gospel")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROMISE OF THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("You the reader must decide whether this is to be understood simply of the gospel which was promised by God through the prophetic Scriptures or whether this is said in order to distinguish it from another gospel, which John calls “eternal” in the book of Revelation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN53",
      "id": "ap_NFIN53-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" This gospel will be revealed when the shadow passes and the truth comes, when death will be swallowed up and eternity restored. It seems that those eternal years of which the prophet spoke also belong to this eternal gospel: “I had the eternal years in mind.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN54",
      "id": "ap_NFIN54-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It must be understood that what was predicted by the prophets concerning Christ was also predicted concerning the gospel, although the Evangelist Mark seems to make a distinction between Christ and the gospel when he says: “Whoever has left father or mother . . . for my sake or for the gospel.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN55",
      "id": "ap_NFIN55-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" But if promises referring specifically to the gospel are what is required, you will find an abun"), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("dance of them in the prophets, to wit: “The Lord will give his word with great power to those who preach the good news,”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN56",
      "id": "ap_NFIN56-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" and: “How beautiful are the feet of those who bring good news.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN57",
      "id": "ap_NFIN57-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN58",
      "id": "ap_NFIN58-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROMISED ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFOREHAND.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER:")])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("“Which he had promised.” In order to prove that the hope of faith was fulfilled and completed in Christ, Paul says that Christ’s gospel was already promised by God beforehand, so that on the basis of the promise Paul could teach that Christ was the perfect author of [eternal] life.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Through his prophets.” In order to show even more clearly that the coming of Christ was a saving event, Paul also indicated the people through whom God gave his promise, so that it might be seen from them just how true and magnificent the promise is. For nobody uses great forerunners to announce some minor thing.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“In the holy scriptures.” Paul added this on top of his argument in order to give greater confidence to believers and show his approval of the law. The Scriptures are holy because they condemn sins and because in them is contained the covenant of the one God and the incarnation of the Son of God for the salvation of mankind, by the evidence of numerous signs. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN59",
      "id": "ap_NFIN59-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HROUGH ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPHETS.")])]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVERIAN: ")]), _vm._v("Paul says “his prophets” because there are also prophets of idols, and by the word "), _c('i', [_vm._v("his")]), _vm._v(" he distinguishes one type of prophet from another and one gospel from another. For there are many gospels, but they are moral and temporary, whereas that of Christ proclaims in the holy Scriptures the enjoyment of eternal blessedness. These prophets are "), _c('i', [_vm._v("his")]), _vm._v(" because they are not of another god but of the Father of Christ. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN60",
      "id": "ap_NFIN60-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD AS ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CT.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("When God is about to do some great thing, he announces it a long time before in order to accustom men’s ears to it, so that when it comes they will accept it. The prophets not only spoke, but they wrote what they spoke; nor did they merely write, but by their very actions they represented what would come, e.g., Abraham when he offered up Isaac;"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN61",
      "id": "ap_NFIN61-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" and Moses when he lifted up the serpent,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN62",
      "id": "ap_NFIN62-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" and when he spread out his hands against Amalek,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN63",
      "id": "ap_NFIN63-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" and when he offered the paschal Lamb."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN64",
      "id": "ap_NFIN64-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN65",
      "id": "ap_NFIN65-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HETHER ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HERE ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPHETS ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MONG THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTILES.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("The prophets arose from the Jewish people, and Paul testifies that the gospel, in which believers are justified by faith, had been promised earlier through them. . . . For there are Gentile prophets as well, in whom also are found some things which they heard of Christ and prophesied. This sort of thing is even said about the Sibyl [Virgil, "), _c('i', [_vm._v("Eclogues")]), _vm._v(" 4.4] . . . but the writings of the Gentiles, so very full of superstitious idolatry, ought not to be considered holy just because they say something about Christ. R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDIMENTARY ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPOSITION OF THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN66",
      "id": "ap_NFIN66-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THER ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST.")])]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS: ")]), _vm._v("Paul preaches no other Christ than the Christ whose gospel the prophets promised would go forth from Jerusalem."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN67",
      "id": "ap_NFIN67-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" He declares that they are prophets of God and that the Scriptures which prophesied about Christ are holy. This entire passage contradicts the Manichaeans,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN68",
      "id": "ap_NFIN68-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" for it says that the gospel was promised beforehand through God’s prophets and in the Holy Scriptures and that according to the flesh Christ came from the lineage of David, i.e., from the Virgin Mary, just as Isaiah had foretold."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN69",
      "id": "ap_NFIN69-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS’S ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN70",
      "id": "ap_NFIN70-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HY ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLY.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR: ")]), _vm._v("The Old Testament is full of predictions of "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Christ’s coming. Paul did not call them “holy” by accident but, first of all, in order to teach that he recognized that the Old Testament was divinely inspired, and secondly, in order to exclude all other writings. For only the divinely inspired Scriptures are of any use. Indeed, Paul says that they are the image of the promise which was to come. I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERPRETATION OF THE ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN71",
      "id": "ap_NFIN71-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-012"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('i', [_vm._v("1:3 ")]), _vm._v("The Gospel Concerning His Son")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON OF ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD AND OF ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID.")])]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GNATIUS: ")]), _vm._v("I glorify God . . . that you are fully persuaded that our Lord was truly of the seed of David according to the flesh and the Son of God according to the will and power of God. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MYRNEANS 1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN72",
      "id": "ap_NFIN72-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVER A ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IME ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ID ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XIST.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("Without any doubt, he was made that which he had not previously been according to the flesh. But according to the Spirit he existed beforehand, and there was never a time when he did not exist. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN73",
      "id": "ap_NFIN73-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONCERNING THE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("“Concerning his Son.” It was fitting, since God promised his own Son to the world, that he should promise him through great men, so that from them it might be known how very powerful the one who was being preached was and so that he might include his future coming in the Holy Scriptures. And what is preached by the Holy Scriptures cannot be shown to be false.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Who was descended from the seed of David according to the flesh.” He who was the Son of God according to the Holy Spirit (that is, according to God, because God is Spirit and without any doubt he is holy), is said to have been made the Son of God according to the flesh by Mary, as it is written: “The Word became flesh.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN74",
      "id": "ap_NFIN74-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" Christ Jesus is both Son of God and Son of Man. As he is truly God, so also he is truly man. For he would not be truly man if he were not of flesh and soul. Otherwise he would be incomplete. For although he was the Son of God in eternity, he was not known by the creation until, when God wanted him to be revealed for the salvation of mankind, he made him visible and corporeal, because God wanted him to be known through his power to cleanse humans from their sins by overcoming death in the flesh. Therefore he was made of the seed of David. As he was born a king from God before the beginning of time, so also he would acquire birth from a king according to the flesh, being made from a virgin by the work of the Holy Spirit,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN75",
      "id": "ap_NFIN75-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" i.e., born. Thus by the reverence reserved for him because of this fact, he who by his birth was distinguished from the law of nature would be recognized as being more than a man. This had been predicted by Isaiah the prophet: “Behold a virgin will conceive in her womb.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN76",
      "id": "ap_NFIN76-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" Hence when the newborn child appeared to be worthy of honor, a certain providence of God was discerned concerning a future visitation of the human race. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN77",
      "id": "ap_NFIN77-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENERATION ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CCORDING TO THE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Paul is here hinting that there is also a generation of Christ according to the Spirit. Why then did he begin from the flesh, and not from the higher principle? First, it was because that was where Matthew, Luke and Mark started from too. Anyone who wants to lead men by hand to heaven must lead them upward from below. This was the way the actual dispensation [of grace] was ordered. First, they saw Christ as a man on earth, and then later they understood that he is God. His disciple therefore followed the same order in which Christ himself had framed his teaching. Thus the generation according to the flesh comes first, not because it was first in actual fact but because he was leading his hearers upward from one thing to the other. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN78",
      "id": "ap_NFIN78-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CCORDING TO THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LESH.")])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS: ")]), _vm._v("Many are sons by grace, but Christ is a son by nature. . . . By adding “according to the flesh” Paul has countered both Photinus and Arius. For if it is true that Christ was made according to the flesh, he most certainly was not made according to the substance of the Word. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS’S ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN79",
      "id": "ap_NFIN79-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-013"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('i', [_vm._v("1:4")]), _vm._v(" Divine and Human, the Son of God")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESIGNATED ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON OF ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("Let no one think that we are reading more into this text than the meaning itself permits. For although in Latin translations one normally finds the word "), _c('i', [_vm._v("predestined")]), _vm._v(" here, the true reading is "), _c('i', [_vm._v("designated")]), _vm._v(" and not "), _c('i', [_vm._v("predestined.")]), _vm._v(" For "), _c('i', [_vm._v("designated")]), _vm._v(" applies to someone who already exists, whereas "), _c('i', [_vm._v("predestined")]), _vm._v(" is only applicable to someone who does not yet exist, like those of whom the apostle said: “For those whom he foreknew he also predestined.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN80",
      "id": "ap_NFIN80-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" . . . Those who do not yet exist may be foreknown and predestined, but he who is and who always exists is not predestined but designated. These things are said by us concerning those who speak blasphemously about the only begotten Son of God and ignoring the difference between "), _c('i', [_vm._v("designated")]), _vm._v(" and "), _c('i', [_vm._v("predestined")]), _vm._v(" think that Christ is to be numbered among those who were predestined before they existed. But he was never predestined to be the Son, because he always was and is the Son, just as the Father has always been the Father. . . . The apostle makes an essential distinction when he says that “from the seed of David according to the flesh” Christ was made, but as “the Son of God in power according to the Spirit of holiness” he is designated.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("And when he says “Son of God” it is not without reason that he adds “in power,” indicating by this that in substance he is the Son according to the Spirit of holiness. For Christ is called “the power of God and the wisdom of God.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN81",
      "id": "ap_NFIN81-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" . . . But we want to know what to make of the soul of Jesus, if what is born of the seed of David is according to the flesh and what is designated in power is according to the Spirit of holiness the Son of God and in the substance of God. The soul, however, is not mentioned either with the flesh, with the Spirit of holiness or with the substance of God’s power, although the Savior himself speaks of it elsewhere: “My soul is very sorrowful, even unto death”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN82",
      "id": "ap_NFIN82-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" and: “Now is my soul troubled.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN83",
      "id": "ap_NFIN83-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" Here he means the soul which he laid aside of his own free will, which went down to hell and of which it is said: “Thou dost not leave my soul in hell.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN84",
      "id": "ap_NFIN84-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" It is certain that this soul was not born of the seed of David, for he says that what was born of the seed of David was according to the flesh.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The soul cannot be included with the things which are according to the flesh, nor in that which is designated Son of God in power according to the Spirit of holiness. I think that the apostle is here following his usual custom, knowing that the soul is always midway between the spirit and the flesh. Either it joins itself to the flesh and is made one with the flesh or it associates itself with the spirit and is made one with the spirit. From this it may be concluded that when the soul is united with the flesh, men become carnal, and that when it is united with the spirit, men become spiritual. For this reason, Paul does not mention the soul independently but only as flesh or spirit. For he knows that the soul must necessarily attach itself to one or other of these, as it does in those to whom he says: “But you are in the flesh and not in the spirit,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN85",
      "id": "ap_NFIN85-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" and: “Whoever joins himself to a harlot is one body with her,” calling the harlot here “flesh” or “body,” but “whoever joins himself to the Lord is one spirit with him.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN86",
      "id": "ap_NFIN86-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Some people come to us raising the most serious problems as to how Christ can be descended from the seed of David when it is clear that he was not born from Joseph, in whom the line of David descends from one generation to the other. Unpleasant as it is to have to argue according to the literal sense of the text, some of our people answer by saying that Mary was already engaged "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("to Joseph and that before they came together, she was found with child by the Holy Spirit. According to the law, she was therefore already united to Joseph’s tribe and family.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN87",
      "id": "ap_NFIN87-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" . . . Whether you think this line of argument is valid is up to you, dear reader, to decide!")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In our opinion, these things must be understood according to the spiritual or allegorical sense, according to which there is no reason why Joseph should not be called the father of Christ, even though he was not his father. For in the generations recorded by Matthew it is stated that Jehoshaphat begat Joram and Joram begat Uzziah,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN88",
      "id": "ap_NFIN88-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" but in 2 Kings it is said that Jehoshaphat begat Ahaziah and Ahaziah begat Joash and Joash begat Amaziah, and Amaziah begat Azariah, who was also called Uzziah."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN89",
      "id": "ap_NFIN89-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" . . . Matthew therefore left three generations out! The explanation for this is surely not to be sought on the historical level but in conjunction with the spiritual understanding. . . . It is therefore enough for us to say, in answer to our opponents, that just as Jesus is called the son of Joseph even though he did not descend from him, and Uzziah is called the son of Joram even though Joram was not his father, so can we also reckon that Christ was born of the seed of David according to the flesh. What we accept as reason and proof in the case of Joram and Joseph must, we think, be allowed to stand in the case of David as well.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("How it is that he who is said to have been made from the seed of David according to the flesh should be the Son of God by his resurrection from the dead is not hard to understand for anyone who has read that it is written: “For it was fitting that he, for whom and by whom all things exist, in bringing many sons to glory, should make the pioneer of their salvation perfect through suffering.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN90",
      "id": "ap_NFIN90-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" Now the end of Christ’s sufferings is the resurrection, and after the resurrection “he will never die again; death no longer has dominion over him.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN91",
      "id": "ap_NFIN91-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" And again: “Even though we once regarded Christ from a human point of view, we regard him thus no longer.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN92",
      "id": "ap_NFIN92-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" Thus everything which is in Christ is now the Son of God.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("How this all relates to him who is designated Son of God in power is hard for us to understand unless we accept that, because of the indissoluble union of the Word and the flesh, everything which pertains to the flesh may be attributed to the Word also, and everything which pertains to the Word may be attributed to the flesh also. For we often find Jesus referred to in either nature as both Christ and Lord. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN93",
      "id": "ap_NFIN93-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECAUSE OF ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESURRECTION FROM THE ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAD.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("When Paul speaks about the Son of God he is pointing out that God is Father, and by adding the Spirit of holiness he indicates the mystery of the Trinity. For he who was incarnate, who obscured what he really was, was then predestined according to the Spirit of holiness to be manifested in power as the Son of God by rising from the dead, as it is written in Psalm 84: “Truth is risen from the earth.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN94",
      "id": "ap_NFIN94-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" For every ambiguity and hesitation was made firm and sure by his resurrection, just as the centurion, when he saw the wonders, confessed that the man placed on the cross was the Son of God."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN95",
      "id": "ap_NFIN95-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" . . . Note that Paul did not say “because of the resurrection of Jesus Christ” but “because of his resurrection from the dead,” because the resurrection of Christ led to the general resurrection. For this power and victory in Christ appears to be all the greater, in that a dead man could do the same things as he did when he was alive. By this fact he appeared to dissolve death, in order to redeem us. Thus Paul calls him our Lord. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN96",
      "id": "ap_NFIN96-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CCORDING TO THE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT OF ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLINESS.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("What is being said here has been made obscure by the complex syntax, and so it is necessary to expound it. What is he actually saying? “We preach,” says Paul, “him who was made "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("of David.” But this is obvious. How then is it obvious that this incarnate person was also the Son of God? First of all, it is obvious from the prophets [cf. v. 2], and this source of evidence is no weak one. And then there is the way in which he was born [cf. v. 3], which overruled the rules of nature. Third, there are the miracles which he did, which were a demonstration of much power, for the words "), _c('i', [_vm._v("in power")]), _vm._v(" mean this. Fourth, there is the Spirit which he gave to those who believe in him, through whom he made them all holy, which is why he adds: “according to the Spirit of holiness.” For only God could grant such gifts. Fifth, there was the resurrection, for he first and he only raised himself, and he also said that this was a miracle which would stop the mouths even of those who believed arrogantly, for he said: “Destroy this temple and in three days I will raise it up.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN97",
      "id": "ap_NFIN97-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN98",
      "id": "ap_NFIN98-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWER. ")])]), _c('span', {
    staticClass: "small"
  }, [_vm._v("[")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SEUDO-]")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSTANTIUS: ")]), _vm._v("By saying “in power” Paul shows that Christ was conceived not in the normal human way, but that he was procreated from a virgin, without intercourse with a man. He also tells us the time from which he was called to the apostolate, viz., from that time when Christ the Lord was raised from the dead. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLY ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER OF ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T. ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN99",
      "id": "ap_NFIN99-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMAN AND ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVINE.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("Paul had to oppose the unbelief of those who accept our Lord Jesus Christ only according to the man whom he put on but do not understand his divinity, which sets him apart from every other creature. R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDIMENTARY ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPOSITION OF THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 4.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN100",
      "id": "ap_NFIN100-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAKNESS AND ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWER.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("Christ is the son of David in weakness according to the flesh but Son of God in power according to the Spirit of sanctification. . . . Weakness relates to David but life eternal to the power of God. R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDIMENTARY ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPOSITION OF THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 5.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN101",
      "id": "ap_NFIN101-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SSUMPTION OF ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMANITY BY THE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD OF ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("Jesus was predestined, so that he who was to be the Son of David according to the flesh should nonetheless be in power the Son of God, according to the Spirit of sanctification, for he was born of the Holy Spirit and the Virgin Mary. This is that unique act, performed in an ineffable manner, the assumption of a man by the Word of God, so that he might truly and properly be called at once the Son of God and the Son of Man—the Son of Man because of the man who was assumed, the Son of God because of the only begotten God who assumed him. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REDESTINATION 15.31.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN102",
      "id": "ap_NFIN102-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LORIFICATION OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("With respect to this predestination Christ was glorified before the foundation of the world, so that as a result of his resurrection from the dead he might have glory at the Father’s right hand, where he now sits. Thus, when he saw that his predestined glorification had come, in order that what had already been done by predestination might now also take place in fact, he prayed: “Father, glorify thou me in thy own presence with the glory which I had with thee before the world was made.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN103",
      "id": "ap_NFIN103-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 105.8.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN104",
      "id": "ap_NFIN104-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESURRECTION. ")])]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS: ")]), _vm._v("Christ was predestined as to the spirit of sanctification, so that because of his incorruptibility he might rise again before anyone else and open the way of resurrection for the children of God. . . . The nature of the resurrection (not of all who rise from the dead but of those who belong to Christ) is prefigured by Christ. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS’S ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN105",
      "id": "ap_NFIN105-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSHIP IN ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWER AND ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSHIP BY ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACE.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA: ")]), _vm._v("As Christ was predestined to be the Son of God in power, so we too "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("have been predestined to be sons of God, not however in power but by grace, having been made worthy of such a calling and having received it only by the will of God the Father. There is a big difference here between Emmanuel and us. For even if he was born of the seed of David according to the flesh, and so we can say that the Son of God was one of us in his humanity, still, in power and in truth he is the natural Son, and it is through him that we are made sons as well. . . . We stand in the same relation to him as images do to their original. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN106",
      "id": "ap_NFIN106-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESURRECTION THE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVOT.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR: ")]), _vm._v("Before his crucifixion and death the Lord Jesus Christ did not appear to be God either to the Jews or even to the disciples. For they were offended by human things, as when they saw him eating and drinking and sleeping and urinating, and not even his miracles made them change their minds. So, for instance, when they saw the miracle which he performed with the sea, they said: “Who is this, that even the sea and the winds obey him?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN107",
      "id": "ap_NFIN107-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" . . . But after he rose from the dead and ascended into heaven, and the Holy Spirit came, and after miracles of every kind which they performed by calling on his adorable name, all those who believed recognized that he was God and the only begotten Son of God. I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERPRETATION OF THE ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN108",
      "id": "ap_NFIN108-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONFIRMATION AS THE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON OF ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD.")])]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN OF ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMASCUS: ")]), _vm._v("By his miracles and resurrection and by the descent of the Holy Spirit, it was made plain and certain to the world that Christ was the Son of God."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN109",
      "id": "ap_NFIN109-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTHODOX ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH 4.18.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN110",
      "id": "ap_NFIN110-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-014"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('i', [_vm._v("1:5 ")]), _vm._v("Grace and Apostleship")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HROUGH ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACE.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("Paul says that he has received grace and apostleship through Christ, the mediator between God and men"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN111",
      "id": "ap_NFIN111-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v("—grace with respect to his patience in many labors and apostleship with respect to his preaching authority. For Christ was himself called an apostle, i.e., one who was sent by the Father, because he said that he had been sent to preach the gospel to the poor."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN112",
      "id": "ap_NFIN112-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" And everything which is his, he gives to his disciples also. Grace is said to be spread on his lips. For he gives grace to his apostles, by which those who are struggling may say: “I worked harder than any of them, though it was not I but the grace of God which is with me.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN113",
      "id": "ap_NFIN113-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" . . . It was only through the grace which had been given to the apostles that the Gentiles, who were strangers from the covenant of God and from the life of Israel,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN114",
      "id": "ap_NFIN114-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" could believe in the gospel. Through this grace it is said that they came to faith because of the preaching of the apostles, and it is recorded that by the grace given to them the sound of the name of Christ went out into all the world, reaching even those who were at Rome. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN115",
      "id": "ap_NFIN115-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TS ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWER ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REDIBLE ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HROUGH ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEDS.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("After the resurrection Christ was revealed as the Son of God in power. He gave grace to make sinners righteous and appointed apostles, of whom Paul says here that he is one, so that the apostleship might be granted by the grace of God’s gift and not because the apostles were Jews. They received this authority from God the Father through Christ the Lord, so that as representatives of the Lord they might make his teaching acceptable by signs of power. Unbelieving Jews, who had been jealous of this power when they saw it in the Savior, were all the more tormented at seeing it admired by the masses in his servants. For power bears witness to the teaching, so that although what is preached is incredible to the world, it might be made credible by deeds. He says that the apostles have been sent to preach the faith to all nations, that they might obey and "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("be saved, that the gift of God may appear to have been granted not only to the Jews but to all the nations, and that this is the will of God, to have pity on all in Christ and through Christ, by the preaching of his ambassadors. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN116",
      "id": "ap_NFIN116-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT OF ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URSELVES.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("See the candor of the servant. He wants nothing to be his own but everything to be his master’s. And indeed it was the Spirit who gave him this freedom. . . . Paul says: “We have not achieved the apostleship by ourselves.” It was not by much labor and toil that we were given this dignity, but we received grace, and the successful result is a part of the heavenly gift. . . . It was the apostles’ duty to go about and preach, but conviction belonged to God, who worked in them. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN117",
      "id": "ap_NFIN117-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACE, ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("POSTLESHIP. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE:")]), _vm._v(" Paul preserves the main point of his case very well, so that no one would dare say that he has been led to the gospel because of the merits of his previous life. How could one claim this, when even the apostles themselves . . . could not have received their own apostleship unless they had first . . . received grace, which cleanses and justifies sinners? R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDIMENTARY ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPOSITION OF THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 6.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN118",
      "id": "ap_NFIN118-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENT BY THE ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLY ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT.")])]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS: ")]), _vm._v("Paul received grace in baptism and apostleship when he was sent by the Holy Spirit,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN119",
      "id": "ap_NFIN119-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" for "), _c('i', [_vm._v("apostle")]), _vm._v(" means “sent” in Greek. The purpose of this was that the Gentiles might submit not to the law but to faith. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS’S ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN120",
      "id": "ap_NFIN120-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-015"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('i', [_vm._v("1:6 ")]), _vm._v("Belonging to Christ")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFFERENT ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLINGS.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("Paul is said to be called to be an apostle, and the Romans are also called, though not to be apostles. Rather they are called to be holy in the obedience of faith. We have already spoken above about the different callings."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN121",
      "id": "ap_NFIN121-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" Co"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MMENTARY ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN122",
      "id": "ap_NFIN122-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLED AND ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENT.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("This is by the mission of us who are preaching the name of Christ to all the nations, among whom you too have been called, because the gift of God has been sent to all, so that when they hear that they have been called along with others, they will know that they must not act as if they are under the law, since the other nations accepted the faith of Christ without the law of Moses. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN123",
      "id": "ap_NFIN123-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCLUDING ")]), _vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURSELVES.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("POLLINARIS OF ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AODICEA: ")]), _vm._v("Paul says this in order to show that the Romans too, made up as they were of all the nations inhabiting the world, rightly accepted the preaching of his message. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN124",
      "id": "ap_NFIN124-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS WITH ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THERS.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Paul does not say that God called the others along with the Romans but the Romans along with the others. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN125",
      "id": "ap_NFIN125-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVATION TO ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EWS AND ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THERS.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("Paul teaches here that this salvation had come not only to the Jews, as some Jewish Christians thought. R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDIMENTARY ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPOSITION OF THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 6.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN126",
      "id": "ap_NFIN126-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPOINTED.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR: ")]), _vm._v("Paul tells them here that he is not doing anything improper, nor invading fields assigned to others, for God had appointed him to preach to the Gentiles. I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERPRETATION OF THE ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN127",
      "id": "ap_NFIN127-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-016"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('i', [_vm._v("1:7 ")]), _vm._v("Grace and Peace to the Saints")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACE AND ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACE. ")])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("The blessing of peace and grace, which the apostle Paul gives to all God’s beloved to whom he is writing, is, I think, analogous to the blessing of Noah on Shem and Japheth,")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN128",
      "id": "ap_NFIN128-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])]), _vm._v(" which was fulfilled in the Spirit toward all those who were blessed in the same way. It is comparable to the blessing with which Abraham was blessed by Melchizedek"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN129",
      "id": "ap_NFIN129-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" and Jacob by his father Isaac,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN130",
      "id": "ap_NFIN130-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" and the twelve patriarchs who were blessed by their father Israel;"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN131",
      "id": "ap_NFIN131-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])]), _vm._v(" or the blessing of Moses, with which he blessed the twelve tribes of Israel."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN132",
      "id": "ap_NFIN132-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" I do not think that the blessing of the apostle’s, by which he blessed the churches of Christ, is inferior to any of these. . . . The apostle writes in the Spirit of God and blesses in the Spirit. Therefore it is through the same Spirit that those who are blessed by the apostle receive their blessings, as long as those on whom the blessing comes are found to be worthy of it. Otherwise it will happen as it is written: “And if a son of peace is there, your peace shall rest upon him; but if not, it shall return to you.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN133",
      "id": "ap_NFIN133-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" What is written about peace will also be the case with grace, because Paul aligns grace with peace. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN134",
      "id": "ap_NFIN134-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATHER AS ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD, ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON AS ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERTULLIAN: ")]), _vm._v("I will not speak of gods at all, nor of lords, but I shall follow the apostle, so that if the Father and the Son are both to be invoked, I shall call the Father “God” and invoke Jesus Christ as “Lord"), _c('i', [_vm._v(".”")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GAINST ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAXEAS 13.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN135",
      "id": "ap_NFIN135-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELOVED IN ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OME.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("“To all God’s beloved in Rome, who are called to be saints.” Although Paul is writing to the Romans, nevertheless he indicates that he is writing to those who are in the love of God. Who are these, if not those who believe rightly concerning the Son of God? These are the ones who are holy and who are said to have been called. For someone who understands incorrectly is not said to have been called, just as those who act according to the law have not rightly understood Christ and have done injury to God the Father, by doubting whether there is full salvation in Christ. Therefore they are not holy, nor are they said to have been called.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Grace to you and peace from God our Father and the Lord Jesus Christ.” Paul says that grace and peace are with those who believe rightly. It is grace by which sinners have been cleansed and peace by which former enemies have been reconciled to the Creator, as the Lord says: “Whatever house you enter and they receive you, say: Peace be to this house.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN136",
      "id": "ap_NFIN136-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])]), _vm._v(" And so as to teach that without Christ there is no peace or hope, Paul added that grace and peace are not only from God the Father but also from the Lord Jesus Christ. He says that God is our Father because of our origin, since all things are from him, and that Christ is Lord, because we have been redeemed by his blood and made children of God. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN137",
      "id": "ap_NFIN137-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUIT OF THE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE: ")]), _vm._v("There is one grace on the part of the Father and the Son, and there is one peace on the part of the Father and the Son, but this grace and peace is the fruit of the Spirit. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLY ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT 11.125.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN138",
      "id": "ap_NFIN138-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOSEN. ")])]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVERIAN: ")]), _vm._v("Paul does not say “to the saints” lightly—for “many are called but few are chosen”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN139",
      "id": "ap_NFIN139-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])]), _vm._v(" and not all have remained in their calling—but so that he would not be throwing holy things to dogs."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN140",
      "id": "ap_NFIN140-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" . . . According to the heretics, if Christ is the Lord and God is "), _c('i', [_vm._v("our")]), _vm._v(" Father, then the Father will be a servant of Christ, for as the son is, so is the father. But it is not like that at all. Paul said that God is our Father, in order to show his grace, and that Christ is Lord, in order that the Romans should not become proud and think that because they too were sons of God they could despise the glory of the Son or raise themselves up beyond what was natural. Paul called God “the Father” because "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("he judges no one, but the Son he called “Lord,” because he is the judge.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN141",
      "id": "ap_NFIN141-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])]), _vm._v(" He calls God “the Father” so as to point out his guardianship over us. He calls the Son “Lord” so that we might understand that we are called sons by the goodness of God but that Jesus is the true God by nature and our Lord. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN142",
      "id": "ap_NFIN142-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLED TO ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AINTS.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("See how often Paul uses the word "), _c('i', [_vm._v("called!")]), _vm._v(" . . . And he does so not out of longwindedness but out of a desire to remind them of the benefit which calling brings. For since it was likely that among those who believed there would be some consuls and rulers as well as poor and common men, Paul casts aside inequality of rank and writes to them all under one common heading. But if in the most important and spiritual things everything is laid out as common to both slaves and free men, e.g., the love of God, the calling, the gospel, the adoption, the grace, the peace, the sanctification, etc., how could it be other than the utmost folly to divide those whom God had joined together and made to be of equal honor in the higher things, for the sake of things on earth? For this reason, I presume, from the very start this blessed apostle casts out this mischievous disease and then leads them to the mother of blessings—humility.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Grace and peace!” Christ told his apostles to make peace their first word when entering into houses."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN143",
      "id": "ap_NFIN143-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])]), _vm._v(" So it is from this that Paul always starts also, for it was no small war which Christ put an end to, but a many-sided and enduring conflict. And it was not because of anything we had done, but by his grace. Since then love presented us with grace and grace with peace . . . he prays over them that they may abide constant and unmoved, so that no other war may ever break out, and he beseeches the God who gave this peace to keep it firmly settled. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN144",
      "id": "ap_NFIN144-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCLUSION.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE OF ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPSUESTIA: ")]), _vm._v("Paul says to all because with Christ everyone is equal. When he says: “to those beloved of God, called to be holy,” he cuts out unbelievers. The forgiveness of sins and the gift of sonship may be what he means by “grace,” and the defeat of the invisible enemies, from whom Christ has delivered us, may be what he means by “peace,” as well as the refusal of the body to rebel against the reasonings of the soul and godly agreement with one another. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN145",
      "id": "ap_NFIN145-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT’S ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFTS. ")])]), _c('span', {
    staticClass: "small"
  }, [_vm._v("[")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SEUDO-]")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSTANTIUS: ")]), _vm._v("“Called to be saints” because he was writing to those who possess the grace of the Holy Spirit, and he therefore preaches that gifts from the Father and the Son are to be bestowed on them. In saying this he is not overlooking the Holy Spirit but showing that the gifts of the Father, Son and Holy Spirit are common to all three. Moreover, Paul the apostle himself frequently demonstrates that the spiritual gifts which are given to men come from the Holy Spirit. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLY ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER OF ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T. ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN146",
      "id": "ap_NFIN146-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MPHASIZING ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACE.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("Here again Paul has emphasized God’s grace rather than the saints’ merit, for he does not say “to those loving God” but rather “to God’s beloved.” R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDIMENTARY ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPOSITION OF THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 7.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN147",
      "id": "ap_NFIN147-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORGIVENESS AND ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECONCILIATION. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("Instead of saying “greetings,” Paul says “Grace to you and peace.” Grace then is from God the Father and the Lord Jesus Christ, by which our sins, which had turned us from God, are forgiven; and from them also is this peace, whereby we are reconciled to God. Since through grace hostilities dissolve once sins are remitted, now we may cling in peace to him from whom our sins alone had torn us. . . . But when these sins have been forgiven through faith in our Lord Jesus "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Christ, we shall have peace with no separation between us and God. R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDIMENTARY ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPOSITION OF THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 8.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN148",
      "id": "ap_NFIN148-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECALLING ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENEFITS. ")])]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS: ")]), _vm._v("Paul is called to be an apostle to all believers, whom God loves impartially, without showing any preference for Jew or Greek. They are saints because of God’s calling, not because of their own holiness. Paul’s greeting is designed to recall God’s benefits and to pray that they may remain perfect in us, because our sins have been freely forgiven. . . . Paul also insists that Jews and Gentiles live in peace, since both of them have received the same grace. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS’S ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN149",
      "id": "ap_NFIN149-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTORES ")]), _vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRTUE. ")])]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENNADIUS OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSTANTINOPLE: ")]), _vm._v("First Paul prays that the Romans might receive the grace of God, by which all believers enjoy salvation. Then he asks for peace, by which God gives to all the restoration of virtue. For the one who accepts the gospel way of life has peace with God. The one who serves him is amenable to everyone. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN150",
      "id": "ap_NFIN150-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c64d8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap1.vue
// module id = 81
// module chunks = 0